__webpack_require__.p = "/Midterm-quatation/";